export var PointsTransactionType;
(function (PointsTransactionType) {
    PointsTransactionType["POINTS_AWARD"] = "pointsAward";
    PointsTransactionType["ADMIN_POINTS_MODIFICATION"] = "adminPointsModification";
    PointsTransactionType["PAYPAL_POINTS_PAYOUT_PENDING"] = "paypalPointsPayoutPending";
    PointsTransactionType["PAYPAL_POINTS_PAYOUT_DONE"] = "paypalPointsPayoutDone";
    PointsTransactionType["PAID_OFF_PLATFORM"] = "paidOffPlatform";
    PointsTransactionType["QUEUED_PAYOUT"] = "queuedPayout";
    /**
     * Key for custom points transactions, such as those created by admins or through special events.		 */
    PointsTransactionType["CUSTOM"] = "custom";
})(PointsTransactionType || (PointsTransactionType = {}));
export var QueuedPayoutTransactionType;
(function (QueuedPayoutTransactionType) {
    QueuedPayoutTransactionType["WAIT_TO_PAYOUT_METHOD"] = "waitToPayoutMethod";
})(QueuedPayoutTransactionType || (QueuedPayoutTransactionType = {}));
export var PointsApplicationState;
(function (PointsApplicationState) {
    PointsApplicationState["APPROVED"] = "APPROVED";
    PointsApplicationState["PENDING"] = "PENDING";
    PointsApplicationState["REJECTED"] = "REJECTED";
    PointsApplicationState["CANCELED"] = "CANCELED";
    PointsApplicationState["ON_HOLD"] = "ON_HOLD";
})(PointsApplicationState || (PointsApplicationState = {}));
